module.exports = __webpack_public_path__ + "img/hotels-hm-hotels.95a962e8.jpg";